// extracted by mini-css-extract-plugin
module.exports = {"emoji":"Emoji_emoji__2SGn7","focusEmoji":"Emoji_focusEmoji__okP9n","celebrateEmoji":"Emoji_celebrateEmoji__3ZBv0"};